import script from "./End.vue?vue&type=script&setup=true&lang=js"
export * from "./End.vue?vue&type=script&setup=true&lang=js"

import "./End.vue?vue&type=style&index=0&id=50f0be8e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f0be8e"]])

export default __exports__